import type { BudgetMessage } from '../../../../types/BudgetMessage';

import type { VesselBudgetFormValues } from './BudgetForm';

export const updateVesselBudgetRequest = (
    values: VesselBudgetFormValues,
    budgetData: BudgetMessage
): BudgetMessage => ({
    ...budgetData,
    budget: {
        ...budgetData.budget,
        amount: Number(values.budget.amount),
    },
    startDate: values.startDate,
});
